import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V2 } from '@studio/constants/env-variables';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V2}/users/me/permissions`,
    response: [] as string[],
    method: HTTP_METHODS.GET,
  },
};

export const id = {};

export const permissions = {
  ...root,
  id,
};
